import { useState, type InputHTMLAttributes } from 'react';
import { parseQtd } from '@fiodecobre/shared';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value' | 'type'> & {
  // Valor canonico, como o form guarda e o backend recebe: '11000' / '11000.5' / ''.
  valor: string;
  onChangeValor: (canonico: string) => void;
  casas?: number;
};

function formatar(valor: string, casas: number): string {
  if (valor === '') return '';
  const n = Number(valor);
  if (!Number.isFinite(n)) return valor;
  return n.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
}

// Quantidade em pt-BR com milhar e casas fixas (`11.000,000`) — pedido dele, 2026-10-01, no
// Est. Atual da ficha: `type="number"` nao sabe separar milhar, e 11000 se le mal de longe.
// ⚠️ Entrega o valor a CADA tecla, nao no blur (como o MoneyInput faz): so no blur o Salvar
// fica apagado enquanto se digita ([DA-657] p.6, sistema/CLAUDE.md). Texto que nao vira numero
// (letra, '-' sozinho) nao entrega — senao apagaria o valor no meio da digitacao.
export function QuantidadeInput({ valor, onChangeValor, casas = 3, onFocus, onBlur, ...rest }: Props) {
  const [editando, setEditando] = useState(false);
  const [textoLocal, setTextoLocal] = useState('');

  return (
    <input
      type="text"
      inputMode="decimal"
      value={editando ? textoLocal : formatar(valor, casas)}
      onFocus={(e) => {
        setEditando(true);
        setTextoLocal(formatar(valor, casas));
        e.currentTarget.select();
        onFocus?.(e);
      }}
      onChange={(e) => {
        const texto = e.currentTarget.value;
        setTextoLocal(texto);
        if (texto.trim() === '') { if (valor !== '') onChangeValor(''); return; }
        const n = parseQtd(texto);
        if (!Number.isFinite(n)) return;
        if (valor !== '' && Number(valor) === n) return;
        onChangeValor(String(n));
      }}
      onBlur={(e) => {
        setEditando(false);
        onBlur?.(e);
      }}
      {...rest}
    />
  );
}
